// frontend/src/pages/ResetPassword.tsx
import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { performPasswordReset } from "../services/auth";
import { showToast } from "../utils/toast";
import Spinner from "../components/ui/Spinner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) { showToast(t("auth.reset_password.error_invalid_link"), "error"); return; }
    setLoading(true);
    try {
      await performPasswordReset(token, password);
      showToast(t("auth.reset_password.success"), "success");
      navigate("/login");
    } catch (err: any) {
      showToast(err?.message || t("auth.reset_password.error"), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-full bg-gray-50 px-4 pt-12 md:pt-16 lg:pt-0 lg:py-8 lg:flex-1 lg:grid lg:place-items-center">
      <div className="mx-auto w-full max-w-md bg-white shadow-md rounded px-8 py-6">
        <h1 className="text-lg font-semibold mb-4">{t("auth.reset_password.title")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("auth.reset_password.new_password")}</label>
            <input
              type="password"
              className="standard-form-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-elani-blue text-white py-2 rounded disabled:opacity-60 flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="mr-2" aria-label={t("auth.reset_password.a11y_saving_label")} />
                {t("common.saving")}
              </>
            ) : (
              t("auth.reset_password.save_password")
            )}
          </button>
        </form>
      </div>
    </div>
  );
}